__turbopack_context__.v({
  "overlapAbove": "AboutUsSiteContainer-module__Zintgq__overlapAbove",
  "overlapBelow": "AboutUsSiteContainer-module__Zintgq__overlapBelow",
  "positionRelative": "AboutUsSiteContainer-module__Zintgq__positionRelative",
  "siteContainer": "AboutUsSiteContainer-module__Zintgq__siteContainer",
  "styles2026": "AboutUsSiteContainer-module__Zintgq__styles2026",
  "twoColumn": "AboutUsSiteContainer-module__Zintgq__twoColumn",
  "twoColumnSwapOnDesktop": "AboutUsSiteContainer-module__Zintgq__twoColumnSwapOnDesktop",
  "wider": "AboutUsSiteContainer-module__Zintgq__wider",
  "withVerticalGaps": "AboutUsSiteContainer-module__Zintgq__withVerticalGaps",
});
